export default __webpack_public_path__ + "static/salao-de-festas-e91241a10ecfd34746a4190f9288b1f6.jpg";